import { cx } from '@linaria/core';
import { memo } from 'preact/compat';
import { i18n } from '../i18n';
import { isAcceptedFile } from '../utils';
import { cssToolbarButtonLike } from './cssToolbarButtonLike';
type ToolbarFileButtonProps = {
  className?: string;
  accept: string;
  disabled?: unknown;
  children: any;
} & ({
  multiple: true;
  onSelectFiles: (file: File[]) => void;
  onSelectFile?: never;
} | {
  multiple?: false;
  onSelectFile: (file: File) => void;
  onSelectFiles?: never;
});
export const ToolbarFileButton = memo((props: ToolbarFileButtonProps) => <label disabled={!!props.disabled} className={cx(cssToolbarButtonLike, props.className)}>
    {props.children}
    <input type="file" hidden accept={props.accept} multiple={props.multiple} onChange={event => {
    const files = [...(event.currentTarget.files ?? [])];
    event.currentTarget.value = '';
    if (files.length === 0) {
      return;
    }
    const accept = props.accept.split(',');
    const unacceptedFiles = files.filter(file => !isAcceptedFile(file, accept));
    if (unacceptedFiles.length !== 0) {
      return alert(`${i18n.unsupportedInputFileType}\n${unacceptedFiles.map(file => file.name).join('\n')}`);
    }
    if (props.multiple) {
      props.onSelectFiles(files);
    } else {
      props.onSelectFile(files[0]);
    }
  }} />
  </label>);